import { GET_INCOME_UNIT_BY_ID, RESET_GET_INCOME_BY_ID } from "../../actionTypes/actionsTypes";
import { AppAction, BaseAsyncReducerState, LocalAction } from "../../types";

export interface GetIncomeUnitState extends BaseAsyncReducerState {
    incomeUnitData: Record<string, unknown>;
}

// Define an initial state value for the app
const initialState: GetIncomeUnitState = {
    loading: false,
    success: false,
    error: false,
    incomeUnitData: {}
}
  
function getincomeUnitReducer(state = initialState, action: AppAction | LocalAction) {

    switch (action.type) {
        case GET_INCOME_UNIT_BY_ID.PENDING:
            return {
                loading: true,
                success: false,
                error: false,
            }

        case GET_INCOME_UNIT_BY_ID.SUCCESS:
            return {
                ...state,
                success: (action as AppAction).payload.success,
                incomeUnitData: (action as AppAction).payload.data,
                loading: false,
                error: false,
            }

        case GET_INCOME_UNIT_BY_ID.ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: true
            }

        case RESET_GET_INCOME_BY_ID:
            return {
                ...initialState
            }

        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}

export default getincomeUnitReducer;